import gallary1 from "../../Assets/Images/about-gallary.png";
import gallary2 from "../../Assets/Images/jared-rice-PibraWHb4h8-unsplash.jpg";
import gallary3 from "../../Assets/Images/li-yang-a8iCZvtrHpQ-unsplash.jpg";

export const gallaryImages = [
  {
    id: 1,
    image: gallary1,
    title: "Massage room",
    description: "Our massier with oil",
  },
  {
    id: 2,
    image: gallary2,
    title: "Shower room",
    description: "After massage you take a shower in this room",
  },
  {
    id: 3,
    image: gallary3,
    title: "Resciption pool",
    description: "Oul loopy",
  },
];
